import { wrapSvgIcon } from "./wrapSvgIcon.jsx";
import { svgDefs } from "./svg-definitions.js";

export default wrapSvgIcon(svgDefs.start_role);
